import type { ConfigProviderProps } from 'antd/es/config-provider'
import { getAntLocale } from './ant-locale'
import { Translations } from '../../../shared/i18n/Translations'

export function getAntConfig(): ConfigProviderProps {
    return {
        theme: {
            token: {
                colorPrimary: '#3c7fdd', // var(--blue-500)', which isn't a semantic color...
                fontFamily: 'var(--base-font)',
                fontWeightStrong: 500,
                colorText: '#4F5B68',
                borderRadius: 4,
                colorBorder: '#b6c1d7',
                colorPrimaryBorder: '1px solid var(--grey6)',
                paddingLG: 16,
                colorBorderSecondary: 'var(--grey5)',
                colorError: '#e3273d', //'var(--red-500)',
                colorErrorBg: '#fcf0f1', //'var(--red-100)',
                colorBgSpotlight: 'var(--teal-500)',
                fontSize: 14,
            },
            components: {
                TreeSelect: {
                    titleHeight: 44,
                    nodeHoverBg: 'var(--blue-100)',
                    colorBgTextHover: 'unset',
                },
                Select: {
                    multipleItemBg: 'var(--grey8)',
                    optionSelectedBg: 'var(--blue-100)',
                    optionActiveBg: 'var(--backgroundGrey)',
                    optionHeight: 40,
                    optionLineHeight: '2em',
                    colorTextPlaceholder: 'var(--grey-500)',
                },
                Form: {
                    itemMarginBottom: 32,
                },
                Card: {
                    colorBorderSecondary: 'var(--grey-300, #DBE0EB)',
                },
                Input: {
                    hoverBorderColor: '#50596C',
                    activeBorderColor: 'var(--purple)',
                },
                Popover: {
                    boxShadowSecondary: 'unset',
                    motionDurationMid: '0',
                },
                Table: {
                    headerSplitColor: 'none',
                    colorBorderSecondary: 'var(--grey-300)',
                    colorText: 'var(--grey-700)',
                    colorSplit: 'var(--transparent-black)',
                    cellPaddingInline: 8,
                    cellPaddingBlock: 0,
                    headerBg: 'var(--white)',
                    rowHoverBg: 'var(--grey-100)',
                    rowSelectedBg: 'var(--grey-200)',
                    rowSelectedHoverBg: 'var(--grey-200)',
                    headerColor: 'var(--grey-600)',
                    headerSortHoverBg: 'inherit',
                    headerSortActiveBg: 'inherit',
                    fixedHeaderSortActiveBg: 'none',
                    bodySortBg: 'inherit',
                },
                Alert: {
                    defaultPadding: '12px 12px',
                    withDescriptionPadding: '12px 12px',
                },
            },
        },
        form: {
            /** ant locale doesn't include optional translation for every lanugage...
             * kept this is case we need this (optional) style in forms in the furture
             * https://ant.design/components/form#components-form-demo-required-mark
             */
            // requiredMark: (
            //     labelNode: React.ReactNode,
            //     info: {
            //         required: boolean
            //     }
            // ) =>
            //     info.required ? (
            //         labelNode
            //     ) : (
            //         <>
            //             {labelNode}
            //             <span className="ant-form-item-optional"> ({window.i18n('shared:common.optional')})</span>
            //         </>
            //     ),
        },

        locale: getAntLocale(Translations.language),
    }
}
